import React, { Component } from 'react'
import { Div, P, Button, H4 } from '@driftt/tide-core';
import { Icon } from '@driftt/tide-icons'
import PropTypes from 'prop-types'
import './styles.css'

const FindMyTeamNotification = () => (
  <H4>We recognize your email domain!</H4>
)

const VideoSignInNotification = () => (
  <H4>Looks like you already have an account!</H4>
)

const FindMyTeamButton = (onClick) => (
  <Button type="primary" className="test" onClick={onClick}>Find my Drift organization</Button>
)

const VideoSignInButton = (onClick) => (
  <Button type="primary" onClick={onClick}>Sign in</Button>
)

const VideoSignInSubtext = () => (
  <P className="subtext-text">This email is already associated with a Drift account. To get started with Drift Video, just sign in with your existing account instead.</P>
)

const FindMyTeamSubtext = () => (
  <P className="subtext-text">It seems like your team is already in Drift - we suggest you join them in their existing Drift organization!</P>
)

const NotificationTextMap = {
  "findMyTeam": FindMyTeamNotification,
  "videoSignIn": VideoSignInNotification
}

const ButtonTextMap = {
  "findMyTeam": FindMyTeamButton,
  "videoSignIn": VideoSignInButton
}

const SubtextMap = {
  "findMyTeam": FindMyTeamSubtext,
  "videoSignIn": VideoSignInSubtext
}

export class DynamicNotification extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    onTrack: PropTypes.func
  }

  componentDidMount() {
    const { onTrack } = this.props
    if (!!onTrack) onTrack()
  }

  render() {
    const { type, onClick, onCreate } = this.props
    return (
      <Div className="dynamic-notification-container">
        <Div className="content-container">
          <Div className="notification-container">
            <Div className="icon-container">
              <Icon className="info-icon" name="info"/>
            </Div>
            <Div className="notification-text-container">
              {NotificationTextMap[type]()}
            </Div>
          </Div>
          <Div className="subtext-container">
            {SubtextMap[type]()}
          </Div>
          <Div className="find-org-button-container">
            {ButtonTextMap[type](onClick)}
          </Div>
          <Div className="create-account-button-container">
            <Button type="subtle" onClick={onCreate}>Create a new Drift account</Button>
          </Div>
        </Div>
      </Div>
    )
  }
}
